module.exports = __webpack_public_path__ + "static/img/attention.acfaa665.png";